import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";


interface SelectDropdownDayProps {
  onSelectDay: (days: number[] | null) => void;
  selectedDays?: number[] | null;
  isDisabled: boolean;
}

const SelectDropdownDay = ({ selectedDays, onSelectDay, isDisabled }: SelectDropdownDayProps) => {
  const dates = Array.from({ length: 32 }, (_, i) => {
    const value = i + 1;
    const label = i === 31 ? 'สิ้นเดือน' : (i + 1);
    return { label, value }
  });
  // console.log('date:', dates);

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      isMulti={true}
      list={dates}
      onValueChanged={(e) => { onSelectDay(e.map((x: any) => x.value)) }}
      selectedValue={dates.filter(x1 => selectedDays?.includes(x1.value))}
    />
  )
}

export default SelectDropdownDay

